import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { itemCount } from "../data/site";

const MotionLink = motion(Link);

export const CategoryCard = ({ category, index, onSelect, to }) => {
  const preview = category.groups.flatMap((g) => g.items).slice(0, 4);
  const cls =
    "group relative block w-full overflow-hidden rounded-3xl border border-white/10 bg-steel/50 p-6 text-left transition-all duration-500 hover:border-blue/40 hover:bg-steel/80 hover:shadow-[0_0_44px_rgba(46,107,255,0.1)] sm:p-7";

  const content = (
    <>
      <div className="flex items-start justify-between">
        <span className="font-display text-5xl font-semibold leading-none text-outline transition-all duration-500 group-hover:[-webkit-text-stroke:1px_#2E6BFF]">
          {String(index + 1).padStart(2, "0")}
        </span>
        <span className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-fog transition-all duration-500 group-hover:border-blue/50 group-hover:text-blue">
          <ArrowUpRight size={16} />
        </span>
      </div>
      <h3 className="mt-6 font-display text-xl font-medium tracking-tight text-cream sm:text-2xl">
        {category.name}
      </h3>
      <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.2em] text-blue">
        {itemCount(category)} products
      </p>
      <div className="mt-5 flex flex-wrap gap-1.5">
        {preview.map((item) => (
          <span
            key={item}
            className="rounded-full border border-white/10 px-3 py-1 text-[11px] text-fog"
          >
            {item}
          </span>
        ))}
        <span className="rounded-full border border-blue/30 px-3 py-1 text-[11px] text-blue">
          + more
        </span>
      </div>
    </>
  );

  const motionProps = {
    layout: true,
    initial: { opacity: 0, y: 32 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, scale: 0.96 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-40px" },
    transition: { duration: 0.7, delay: (index % 3) * 0.07, ease: [0.22, 1, 0.36, 1] },
  };

  if (to) {
    return (
      <MotionLink to={to} data-testid={`category-card-${category.id}`} className={cls} {...motionProps}>
        {content}
      </MotionLink>
    );
  }
  return (
    <motion.button
      onClick={() => onSelect(category)}
      data-testid={`portfolio-item-card-${index}`}
      className={cls}
      {...motionProps}
    >
      {content}
    </motion.button>
  );
};
